import { doc, updateDoc, increment, setDoc, getDoc } from "firebase/firestore";
import { db } from "./firebase";

export async function countUniqueVisit() {
  const alreadyCounted = localStorage.getItem("visitor_counted");

  if (alreadyCounted) return;

  const ref = doc(db, "stats", "visitors");
  const snap = await getDoc(ref);

  if (!snap.exists()) {
    await setDoc(ref, { totalVisits: 1 });
  } else {
    await updateDoc(ref, {
      totalVisits: increment(1),
    });
  }

  localStorage.setItem("visitor_counted", "true");
}